function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import treeStyles from '@dtsl/css-tree-view/dist/index.module.css';
const ListWrapper = _ref => {
  let {
    children,
    className = '',
    styles = {},
    dataAtrributes = {}
  } = _ref;
  return /*#__PURE__*/React.createElement("ul", _extends({
    className: `${treeStyles['sib-tree-view']} ${className}`,
    style: styles,
    role: "tree"
  }, dataAtrributes), children);
};
ListWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  styles: PropTypes.object,
  dataAtrributes: PropTypes.object
};
export default ListWrapper;